import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PresenceBadge from '@/components/PresenceBadge';
import { useEducandos } from '@/hooks/useGuardian';
import { ageOn, educandoName } from '@/lib/educando';

/** A guardian's home: the participants the Centro linked to their account. */
export default function EducandosPage() {
  const query = useEducandos();
  const educandos = query.data?.educandos ?? [];

  return (
    <>
      <Helmet>
        <title>Educandos | AICD</title>
      </Helmet>
      <div className="space-y-6">
        <header>
          <h1 className="text-2xl font-black text-foreground">Os meus educandos</h1>
          <p className="mt-1 subtitle text-sm text-muted-foreground">
            Veja se estão num Centro e acompanhe o percurso de cada um.
          </p>
        </header>

        {query.isLoading && (
          <ul className="space-y-3" aria-hidden="true">
            {[0, 1].map((i) => (
              <li key={i} className="h-24 animate-pulse rounded-2xl border border-border bg-card" />
            ))}
          </ul>
        )}

        {query.isError && !query.isLoading && (
          <div role="alert" className="rounded-2xl border border-busy/50 bg-busy-soft p-4 text-sm text-busy">
            Não foi possível carregar os seus educandos. Tente novamente mais tarde.
          </div>
        )}

        {!query.isLoading && !query.isError && educandos.length === 0 && (
          <div className="rounded-2xl border border-dashed border-border-strong bg-card p-6 text-sm text-muted-foreground">
            <p className="font-bold text-foreground">Ainda não tem educandos associados.</p>
            <p className="mt-2">
              A equipa do Centro confirma quem são os seus educandos e associa-os à sua conta. Se
              já passou algum tempo, fale com o Centro.
            </p>
          </div>
        )}

        {educandos.length > 0 && (
          <ul className="space-y-3">
            {educandos.map((e) => (
              <li key={e.id}>
                <Link
                  to={`/educandos/${e.id}`}
                  className="block rounded-2xl border border-border bg-card p-4 shadow-sm transition hover:border-border-strong focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
                >
                  <p className="text-base font-black text-foreground">{educandoName(e)}</p>
                  <p className="mt-0.5 text-xs text-muted-foreground">
                    {ageOn(e.dataNascimento)} anos
                    {e.digitalCenterName && ` · ${e.digitalCenterName}`}
                  </p>
                  <div className="mt-3">
                    <PresenceBadge educando={e} />
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
}
